import { mergeStyles } from "@fluentui/react";
import React from "react";

export const fullScreenWidthAndHeightStyles = { width: '100dvw', height: '100dvh' };
export const fillWidthAndHeightStyles = { width: '100%', height: '100%' };
export const fillWidthStyles = { width: '100%' };

export const hiddenOverflowStyles: React.CSSProperties = { overflow: 'hidden' };
